import { useSelector } from 'react-redux';
import { useLocalStorage } from 'react-use';

import { getUserID } from '@app/store/user/user/selectors';

interface CompositeOrdering<T = string> {
  order: 'asc' | 'desc';
  orderBy: T;
}

type OrderingsState = CompositeOrdering<
  'registrationNumber' | 'title' | 'dateOfCompletion' | 'status' | 'updatedAt'
>;

const initialValue: OrderingsState = {
  order: 'desc',
  orderBy: 'updatedAt',
};

export default function useOrdering() {
  const userId = useSelector(getUserID);
  const [localStorageOrderings, setOrderingsStorage] = useLocalStorage<OrderingsState>(
    `external-document-orderings-${userId}-v1`,
    initialValue
  );

  const orderings = localStorageOrderings || initialValue;

  return {
    ordering: orderings,
    setOrdering: setOrderingsStorage,
    initOrdering: () => {
      setOrderingsStorage(initialValue);
    },
  };
}
